import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.config.productionTip = false;

function preventPageZoom() {
  document.addEventListener(
    "wheel",
    (event) => {
      if (event.ctrlKey) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  document.addEventListener(
    "keydown",
    (event) => {
      const isZoomShortcut =
        (event.ctrlKey || event.metaKey) &&
        ["+", "=", "-", "_", "0"].includes(event.key);

      if (isZoomShortcut) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  ["gesturestart", "gesturechange", "gestureend"].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        event.preventDefault();
      },
      { passive: false }
    );
  });
}

function preventImageDrag() {
  document.addEventListener(
    "dragstart",
    (event) => {
      if (event.target && event.target.tagName === "IMG") {
        event.preventDefault();
      }
    },
    { passive: false }
  );
}

preventPageZoom();
preventImageDrag();

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
// main.js
function setRem() {
  const designWidth = 1920; // 设计稿宽度
  const baseSize = 100; // 基准值（1rem = 100px，方便计算）

  // 计算缩放比例
  let scale = document.documentElement.clientWidth / designWidth;

  // 限制最小和最大缩放比例（可选）
  scale = Math.min(scale, 1); // 最大不超过 1（不放大）
  scale = Math.max(scale, 0.5); // 最小不小于 0.5

  // 设置根字体大小
  document.documentElement.style.fontSize = baseSize * scale + "px";
}

// 初始化
if (isMobile) {
  setRem();
}

let lastWindowSize = `${window.innerWidth}x${window.innerHeight}`;
let reloadTimer = null;

function reloadPageWithCurrentPath() {
  const currentWindowSize = `${window.innerWidth}x${window.innerHeight}`;

  if (currentWindowSize === lastWindowSize) {
    return;
  }

  lastWindowSize = currentWindowSize;
  clearTimeout(reloadTimer);
  reloadTimer = setTimeout(() => {
    window.location.reload();
  }, 500);
}

// 窗口大小变化时重新计算并刷新当前页面，reload 会保留当前路径、查询参数和 hash
window.addEventListener("resize", () => {
  setRem();
  reloadPageWithCurrentPath();
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
